export default "__VITE_ASSET__ba0db343__"